import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Trash2, Edit, Plus } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function TestimonialsAdmin() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', text: '', rating: 5, date: '', order: 0 });

  useEffect(() => { fetchItems(); }, []);

  const fetchItems = async () => {
    try {
      const { data } = await axios.get(`${API}/api/admin/testimonials`, { withCredentials: true });
      setItems(data.sort((a, b) => a.order - b.order));
    } catch (err) { toast.error('Veri yüklenemedi'); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        await axios.put(`${API}/api/admin/testimonials/${editing.id}`, form, { withCredentials: true });
        toast.success('Güncellendi');
      } else {
        await axios.post(`${API}/api/admin/testimonials`, form, { withCredentials: true });
        toast.success('Eklendi');
      }
      setEditing(null);
      setForm({ name: '', text: '', rating: 5, date: '', order: 0 });
      fetchItems();
    } catch (err) { toast.error('İşlem başarısız'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Emin misiniz?')) return;
    try {
      await axios.delete(`${API}/api/admin/testimonials/${id}`, { withCredentials: true });
      toast.success('Silindi');
      fetchItems();
    } catch (err) { toast.error('Silinemedi'); }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-slate-900">Hasta Yorumları</h1>
        <button 
          onClick={() => { setEditing(null); setForm({ name: '', text: '', rating: 5, date: '', order: 0 }); }}
          className="bg-primary text-white px-4 py-2 rounded-xl flex items-center gap-2 hover:bg-primary/90"
        >
          <Plus className="w-4 h-4" /> Yeni Ekle
        </button>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        <div className="md:col-span-1 bg-white p-6 rounded-2xl shadow-sm border border-slate-200 h-fit">
          <h2 className="text-lg font-bold mb-4">{editing ? 'Yorum Düzenle' : 'Yeni Yorum'}</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Hasta Adı</label>
              <input type="text" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required className="w-full px-3 py-2 border rounded-xl" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Tarih / Zaman</label>
              <input type="text" value={form.date} onChange={e => setForm({...form, date: e.target.value})} placeholder="Örn: 2 hafta önce" required className="w-full px-3 py-2 border rounded-xl" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Yorum Metni</label>
              <textarea value={form.text} onChange={e => setForm({...form, text: e.target.value})} required rows={4} className="w-full px-3 py-2 border rounded-xl" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Yıldız (1-5)</label>
              <input type="number" min="1" max="5" value={form.rating} onChange={e => setForm({...form, rating: Number(e.target.value)})} required className="w-full px-3 py-2 border rounded-xl" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Sıra</label>
              <input type="number" value={form.order} onChange={e => setForm({...form, order: Number(e.target.value)})} className="w-full px-3 py-2 border rounded-xl" />
            </div>
            <div className="flex gap-2 pt-2">
              <button type="submit" className="flex-1 bg-primary text-white py-2 rounded-xl text-sm font-medium">Kaydet</button>
              {editing && <button type="button" onClick={() => setEditing(null)} className="flex-1 bg-slate-100 text-slate-700 py-2 rounded-xl text-sm font-medium">İptal</button>}
            </div>
          </form>
        </div>

        <div className="md:col-span-2 bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
          <table className="w-full text-left text-sm text-slate-600">
            <thead className="bg-slate-50 border-b border-slate-100 text-slate-500">
              <tr>
                <th className="px-6 py-3 font-medium">İsim</th>
                <th className="px-6 py-3 font-medium">Yorum</th>
                <th className="px-6 py-3 font-medium">Sıra</th>
                <th className="px-6 py-3 font-medium text-right">İşlem</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {items.map((item) => (
                <tr key={item.id} className="hover:bg-slate-50/50">
                  <td className="px-6 py-4 font-medium text-slate-900">{item.name}</td>
                  <td className="px-6 py-4 line-clamp-2">{item.text}</td>
                  <td className="px-6 py-4">{item.order}</td>
                  <td className="px-6 py-4 text-right space-x-2">
                    <button onClick={() => { setEditing(item); setForm(item); }} className="text-blue-600"><Edit className="w-5 h-5 inline" /></button>
                    <button onClick={() => handleDelete(item.id)} className="text-red-500"><Trash2 className="w-5 h-5 inline" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
